import { onReady } from '../../shared/utils/helpers';
import Base from '../../components/base/base';
import Header from '../../components/header/header';
import PageLoader from '../../components/page-loader/page-loader';
import './home.scss';

interface HomePageOptions {
  debug?: boolean;
  [key: string]: any;
}

class HomePage extends Base {
  private header: Header;

  private loader: PageLoader;

  constructor(options: HomePageOptions = {}) {
    super(options.debug || false);
    this.debug = options.debug || false;

    this.header = new Header({ debug: this.debug });
    this.loader = new PageLoader({
      debug: this.debug,
      oncePerPageSession: true,
      pageKey: window.location.pathname,
    });

    this.init();
  }

  init(): void {
    this.loader.start();
    this.log('HomePage initialized');
  }
}

onReady(() => {
  new HomePage({ debug: true });
});

export default HomePage;